var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border border-red-500 bg-red-100 p-4 text-red-800"},[_c('div',{staticClass:"font-bold"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"mt-2"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }